export const normalizeClassLevel = (value: string | number | null | undefined): number | null => {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const normalized = Number(value)
  return Number.isFinite(normalized) ? normalized : null
}

export const isSameClassLevel = (
  left: string | number | null | undefined,
  right: string | number | null | undefined,
): boolean => {
  const normalizedLeft = normalizeClassLevel(left)
  const normalizedRight = normalizeClassLevel(right)

  return normalizedLeft !== null && normalizedRight !== null && normalizedLeft === normalizedRight
}
